<div *ngIf="card" mat-dialog-content>
  <!--Delete-->
  <button (click)="onOpenDeleteModalCard()" class="close" data-dismiss="modal" type="button">&times;</button>
</div>
<div *ngIf="card" class="card-item">
  <!-- Card Info -->
  <div class="card-item-info">
    <div class="card-image">
      <img [alt]="card.brand" [src]="cardBrand">
    </div>
    <div class="card-info">
      <p>
        <span class="card-number">******** {{ card.last4 }}</span>
        <span class="card-expiry-cvc">{{ card.exp_month }} / {{ card.exp_year }}</span>
      </p>
    </div>
  </div>
  <!-- Card Actions -->
  <div class="card-item-actions">
    <ul>
      <!-- Default -->
      <li *ngIf="card.id === defaultCard" class="active">
        Default
      </li>
      <!-- Set Default -->
      <li *ngIf="card.id !== defaultCard">
        <a (click)="onSetCardDefault()" class="set-default">Set Default</a>
      </li>
      <!-- Delete -->
      <!--<li class="danger" *ngIf="cardOptions.cardIndex !== 0">-->
      <!--<a (click)="onOpenDeleteModalCard()">Remove</a>-->
      <!--</li>-->
    </ul>
  </div>
</div>
